import { createFileRoute } from "@tanstack/react-router";
import { Scanner } from "@/features/labels/scanner/scanner";

export const Route = createFileRoute("/qr/$code")({
  component: ScannedRoute,
});

/** The address a phone's camera app ends on: the same screen as a scan on the scanner. */
function ScannedRoute() {
  const { code } = Route.useParams();
  return <Scanner code={code} invalid={null} />;
}
